import { mapboxAddressExpression } from './expressions'

export const accessorBuilder = <T>(initialValue: T) => ({
  value: initialValue,
  set currentValue(value: T) {
    this.value = value
  },
  get currentValue() {
    return this.value
  },
})

export const extractMapboxAddress = (value: string) => {
  return value.match(mapboxAddressExpression)?.groups
}
